// extracted by mini-css-extract-plugin
export default {"cardAnswer":"Answer_cardAnswer__fst6j","title":"Answer_title__N+2Yg","subtitle":"Answer_subtitle__CfLt7"};